// extracted by mini-css-extract-plugin
export default {"avatarContent":"ProfileAvatar_avatarContent__RXdnI","nameAvatar":"ProfileAvatar_nameAvatar__0mhB0"};